import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/shared/providers/AuthProvider";

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Soft dim placeholder while auth is initialising. Same recipe as
    // the in-dashboard initial-load overlay — semi-transparent surface
    // tint, no backdrop-blur (blur shimmers during the fade transition
    // which reads as eye-straining on text-dense layouts). The header
    // refresh icon (rendered downstream) is the canonical "is loading"
    // signal.
    return (
      <div
        className="absolute inset-0 z-10 pointer-events-none bg-surface/60"
        aria-label="Authenticating"
        role="status"
        data-testid="auth-glass-loader"
      />
    );
  }

  if (!isAuthenticated) {
    // Preserve the intended destination so Login can redirect back after auth.
    // Using React Router <Navigate> keeps the browser history stack intact
    // (no full-page reload), which is required for the back button to work.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
